export const ACCESS_TOKEN_STORE_KEY = 'accessToken';
export const REFRESH_TOKEN_STORE_KEY = 'refreshToken';
export const ACCESS_TOKEN_V2_STORE_KEY = 'accessTokenV2';
export const REFRESH_TOKEN_V2_STORE_KEY = 'refreshTokenV2';

export const getAccessToken = () => {
  return sessionStorage.getItem(ACCESS_TOKEN_STORE_KEY);
};

export const getRefreshToken = () => {
  return sessionStorage.getItem(REFRESH_TOKEN_STORE_KEY);
};

export const getAccessTokenV2 = () => {
  return sessionStorage.getItem(ACCESS_TOKEN_V2_STORE_KEY);
};

export const storeTokens = (accessToken: string, refreshToken: string) => {
  sessionStorage.setItem(ACCESS_TOKEN_STORE_KEY, accessToken);

  // if we do BLT-710 (keep me signed in), we need to store the refresh token in localStorage
  sessionStorage.setItem(REFRESH_TOKEN_STORE_KEY, refreshToken);
};

export const storeTokensV2 = (
  accessTokenV2: string,
  refreshTokenV2: string,
) => {
  sessionStorage.setItem(ACCESS_TOKEN_V2_STORE_KEY, accessTokenV2);
  sessionStorage.setItem(REFRESH_TOKEN_V2_STORE_KEY, refreshTokenV2);
};

export const clearSession = () => {
  sessionStorage.removeItem(ACCESS_TOKEN_STORE_KEY);
  sessionStorage.removeItem(REFRESH_TOKEN_STORE_KEY);
  sessionStorage.removeItem(ACCESS_TOKEN_V2_STORE_KEY);
  sessionStorage.removeItem(REFRESH_TOKEN_V2_STORE_KEY);
};
